import React from 'react';
import { DateTime } from 'luxon';

import { Text, TextType } from 'ui-components/components/text';

import { useProductDetailsContext } from '../../../use-product-details-context';
import { messages } from '../../../messages';
import generalStyle from '../../../style.module.less';
import style from './style.module.css';

const formatUtcDate = (dateUtc: string | undefined): string => {
  if (!dateUtc) return '';
  return DateTime.fromISO(dateUtc, { zone: 'utc' }).toFormat("MM/dd/yyyy HH:mm 'UTC'");
};

export const ProductDetailsAdminV3 = () => {
  const { modifiedDateUtc, productId, createDateUtc, hasHadInventory } = useProductDetailsContext();

  return (
    <>
      <div className={generalStyle['shipping-defaults-header-wrapper']}>
        <Text className={generalStyle['shipping-defaults-header-text']} element='div' textType={TextType.H4} value={messages.adminHeader} />
      </div>
      <div className={style.wrapper}>
        <Text className={generalStyle['rightside-label']} element='div' textType={TextType.Label} value={messages.productId} />
        <div className={style.value}>{productId}</div>
        <Text className={generalStyle['rightside-label']} element='div' textType={TextType.Label} value={messages.createDate} />
        <div className={style.value}>{formatUtcDate(createDateUtc)}</div>
        <Text className={generalStyle['rightside-label']} element='div' textType={TextType.Label} value={messages.modifiedDate} />
        <div className={style.value}>{formatUtcDate(modifiedDateUtc)}</div>
        <Text className={generalStyle['rightside-label']} element='div' textType={TextType.Label} value={messages.hasHadInventory} />
        <div className={style.value}>{hasHadInventory != null && String(hasHadInventory)}</div>
      </div>
    </>
  );
};
